import navLogo from "../assets/navLogo.png"; // Ensure the logo is in the assets folder
import { useState } from 'react';
import { Menu } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md py-1 px-2 fixed top-0 left-0 w-full z-50">
  <div className="container mx-auto">
    <div className="flex justify-between items-center">
      {/* Logo */}
      <a href="/">
        <img src={navLogo} alt="Company Logo" className="w-40 h-25" />
      </a>

      {/* Mobile Menu Button */}
      <button 
        className="md:hidden"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Menu className="h-6 w-6 text-gray-700" />
      </button>

      {/* Navigation Links - Desktop */}
      <div className="hidden md:flex space-x-4">
        <a href="/" className="text-gray-700 hover:text-[#2E8B57]">Home</a>
        <a href="/about" className="text-gray-700 hover:text-[#2E8B57]">About</a>
        <a href="/membership" className="text-gray-700 hover:text-[#2E8B57]">Membership</a>
        <a href="/programs" className="text-gray-700 hover:text-[#2E8B57]">Programs</a>
        <a href="/mentee" className="text-gray-700 hover:text-[#2E8B57]">Our Mentees</a>
        <a href="/contact" className="text-gray-700 hover:text-[#2E8B57]">Contact</a>
      </div>
    </div>

    {/* Navigation Links - Mobile */}
    <div className={`${isOpen ? 'block' : 'hidden'} md:hidden mt-2`}>
      <div className="flex flex-col space-y-2">
        <a href="/" className="text-gray-700 hover:text-[#2E8B57] py-1">Home</a>
        <a href="/about" className="text-gray-700 hover:text-[#2E8B57] py-1">About</a>
        <a href="/membership" className="text-gray-700 hover:text-[#2E8B57] py-1">Membership</a>
        <a href="/programs" className="text-gray-700 hover:text-[#2E8B57] py-1">Programs</a>
        <a href="/mentee" className="text-gray-700 hover:text-[#2E8B57] py-1">Our Mentees</a>
        <a href="/contact" className="text-gray-700 hover:text-[#2E8B57] py-1">Contact</a>
      </div>
    </div>
  </div>
</nav>

  );
};

export default Navbar;
